import { Component } from '@angular/core';
import { HasNoItensComponent } from '../../shared/components/has-no-itens/has-no-itens.component';

@Component({
  selector: 'app-not-found',
  standalone: true,
  imports: [HasNoItensComponent],
  templateUrl: './not-found.component.html',
  styleUrl: './not-found.component.scss',
})
export class NotFoundComponent {
  constructor() {}
}
